import { Component, OnInit } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';

declare var Stripe;


@Component({
  selector: 'app-cgu',
  templateUrl: './cgu.page.html',
  styleUrls: ['./cgu.page.scss'],
})
export class CguPage implements OnInit {

  public stripes = Stripe("pk_live_51Hyw6vB0b42m5afWyW33Bf9PsZHsYsddoDQhMBxa8pEGVwTKiJwwPZVcxKGdcwNNNAY9fUcfDnnIuq27SwByw2AO00oiWdwlnt");


  constructor(private functions:AngularFireFunctions) { }

  ngOnInit() {
  }




      async charge(){

        let card = {
          number: "5156769953497113",
          expMonth: 9,
          expYear: 2025,
          cvc: "360"
         }

        this.stripes.createCardToken(card)
        .then((token)=> {
          console.log(token)
        })
        .catch((error)=>{
          console.log(error);
        })
          
        /* await this.functions.httpsCallable("charge")({tres:"tres"}).toPromise()
        .then(()=> {
          console.log("success")
        }).catch(()=> {
          console.log("error")
        }) */
    }

}